import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { Button } from '@/common/components/Button.tsx'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useNavigate } from 'react-router-dom'
import { Card, CardContent, CardHeader } from '@/common/components/Card.tsx'
import { CheckCircleIcon, ClockIcon } from '@/app/common/icons/general'
import { resetPayProviderData } from '@/storage/applications/providerPaySlice'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { PaymentStatus } from '@/schemas/payments.schema.ts'

type Props = {
  status: PaymentStatus
}

const ProviderPaySuccess = ({ status }: Props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1 className="text-3xl font-medium text-gray-900">
          {status === 'Approved'
            ? 'Payment processed successfully'
            : 'Payment request in review'}
        </h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className="items-center justify-center">
        {status === 'Approved' ? (
          <CheckCircleIcon className="text-7xl text-green-400 mb-7" />
        ) : (
          <ClockIcon className="text-7xl text-primary mb-7" />
        )}
        <h2 className="text-xl font-medium text-center text-gray-800 mb-8">
          {status === 'Approved'
            ? 'Your payment has been processed successfully'
            : 'Your payment request is under review'}
        </h2>

        <Card className="w-full flex-shrink-0">
          <CardHeader className="flex items-center sm:px-3 justify-between">
            <h3 className="font-medium text-md">Information</h3>
          </CardHeader>

          <CardContent className="w-full">
            <ul>
              <li className="flex items-center justify-between py-2">
                <span className="text-neutral-700">Payment Status</span>
                <span className="text-neutral-900 font-medium">{status}</span>
              </li>
              <li className="flex items-center justify-between py-2">
                <span className="text-neutral-700">Processing Time</span>
                <span className="text-neutral-900 font-medium">
                  {status === 'Approved'
                    ? 'Processed Immediately'
                    : 'Within 24 Hours'}
                </span>
              </li>
            </ul>
          </CardContent>
        </Card>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar className="flex-col">
        <Button
          onClick={() => {
            dispatch(resetPayProviderData())
            navigate(AppRoutePaths.home.index)
          }}
          className="h-9 mb-5"
        >
          {t('return_to_home')}
        </Button>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}
export default ProviderPaySuccess
